module.exports = __webpack_public_path__ + "media/images/category_icons/instagram_channels-78022ba56805fd7cef114c6dacdd15bb.svg";